<template>
    <div class="u-menu">
        <el-scrollbar>
            <el-menu class="el-menu-vertical-demo" :collapse="isCollapse" :default-active="$route.name">
                <div v-for="(route, index) in menus" :key="index">
                    <!-- meta中未配置图标则为默认图标 el-icon-menu -->
                    <!-- 标题未配置则为name -->
                    <div v-if="!route.hidden">
                        <!-- 含子页面 -->
                        <el-submenu :index="route.name" v-if="route.children && route.children.length > 1 && route.name" v-authority="route.meta ? route.meta.authCode || '' : ''">
                            <template slot="title">
                                <div>
                                    <i :class="route.meta ? route.meta.icon || route.icon : route.icon"></i>
                                    <span slot="title">{{ route.meta ? $t(route.meta.title) : $t(route.name) }}</span>
                                </div>
                            </template>
                            <!-- 子页面 -->
                            <div v-for="(item, index) in route.children" :key="index">
                                <el-menu-item  v-if="!item.hidden" :index="item.name" @click="jump(item.path)" v-authority="item.meta ? item.meta.authCode || '' : ''">
                                    <span slot="title">{{ item.meta ? $t(item.meta.title) : $t(item.name) }}</span>
                                </el-menu-item>
                            </div>
                        </el-submenu>
                        <!-- 单页面 -->
                        <el-menu-item
                            v-else-if="route.children && route.children.length > 0"
                            :index="route.children[0].name"
                            @click="jump(route.children[0].path)"
                            v-authority="route.children[0].meta ? route.children[0].meta.authCode || '' : ''"
                        >
                            <i :class="route.children[0].meta ? route.children[0].meta.icon || 'el-icon-tickets' : 'el-icon-tickets'" style="margin:0 4px;"></i>
                            <span slot="title">{{ route.children[0].meta ? $t(route.children[0].meta.title) : $t(route.children[0].name) }}</span>
                        </el-menu-item>
                    </div>
                </div>
            </el-menu>
        </el-scrollbar>
    </div>
</template>
<script>
export default {
    name: 'Menu',
    props: ['isCollapse'],
    data() {
        return {
            menus: []
        }
    },
    mounted() {
        this.menus = JSON.parse(JSON.stringify(this.$router.options.routes))
        console.log(this.menus)
    },
    methods: {}
}
</script>
<style lang="scss" scoped>
.el-scrollbar {
    height: calc(100% + 17px);
    width: 100%;
}
.el-scrollbar .el-scrollbar__wrap {
    overflow-y: scroll;
    width: 110%;
}
</style>
